import { Facebook, Google } from "@mui/icons-material";
import React, { useContext, useEffect } from "react";

import { ThemeContext } from "../../../context/theme/ThemeContext";
import { AuthContext } from "../../../context/auth/ApiContext";
import Style from "./login.module.scss";
import FacebookLogin from "react-facebook-login";
import GoogleLogin from "react-google-login";
import { Link, useLocation, useHistory } from "react-router-dom";
import { TextInput } from "../../../components";
import { CircularProgress } from "@mui/material";
import { login } from "../../../context/auth/apiCalls";
import { toast, ToastContainer } from "react-toastify";
import { errorMessage } from "../../../utils/notification";
import axios from "axios";

import Language from "../../../i18n/english.json";
import { settingContext } from "../../../context/Setting/Setting";
import { useQuery } from "../../../utils/query-parameter";
import { _storeData } from "../../../utils/local-storage";
import { Company, Footer, MenuBar } from "../../../layout/welcome";

const Login = () => {
  const { theme } = useContext(ThemeContext);
  const { page, loading } = React.useContext(settingContext)
  const [isLoading, setLoading] = React.useState(false);
  const [input, setInput] = React.useState({});
  const { user, dispatch, isFetching } = useContext(AuthContext);
  const history = useHistory();
  const query = useQuery();
  const type = query.get('type');

  const handleInputs = (label, e) => {
    var val = e.target.value;
    setInput({ ...input, [label]: val });
  };

  useEffect(() => {
    setLoading(false);
    // if (user) {
    //   let url = "/student/home";
    //   history.push(url);
    // }
  }, [user]);

  const loginFunction = async (e) => {
    e.preventDefault();
    setLoading(true);
    input["device_name"] = navigator.userAgent;
    try {
      const { data, message } = await axios
        .post(process.env.REACT_APP_API_URL + "/auth/login", input, {
          "Content-type": "application/json",
        })
      await _storeData(data?.data?.token, "user_token")
      await _storeData(data?.data?.user, "user_info");
      setLoading(false);
      if (data?.data?.membership) {
        history.push('/student/home');
      } else {
        history.push("/student/membership");
      }
    } catch (error) {
      const err = error?.response?.data;
      errorMessage(toast, err.message);
    }
    setLoading(false);
  };

  const responseFacebook = (response) => {
    console.log(response);
  };

  const responseGoogle = (response) => {
    console.log(response);
  };

  return (
    <div id="page-top" class="home">
      <div id="page-wrap">
        <MenuBar menuIndex="auth" setting={page?.setting} loader={loading} />
        <section id="login-content" className="login-content" >
          <div className="awe-parallax bg-login-content" style={{ backgroundImage: 'url(../img/bg.jpg)' }}></div>
          <div className="awe-overlay" />
          <div className="container">
            <div className="">

              <div className=" md:float-right">
                <div className="form-login">
                  <form>
                    <h2 className="text-uppercase">sign in</h2>
                    <div className="form-email">
                      <input
                        type="text"
                        onChange={(e) => handleInputs("email", e)}
                        className="l_r_b"
                        placeholder="Email"
                      />
                    </div>
                    <div className="form-password">
                      <input
                        onChange={(e) => handleInputs("password", e)}
                        type="password"
                        placeholder="Password" />
                    </div>
                    <div className="form-check">
                      <input type="checkbox" id="check" />
                      <label htmlFor="check">
                        <i className="icon mdi mdi-check" />
                        Remember me</label>
                      <br /> <hr /> <br />
                      <Link to={"/auth/resetpassword"}>Forget password?</Link>
                    </div>
                    <div className="form-submit-1">
                      <button
                        disabled={isLoading}
                        onClick={loginFunction}
                        type="submit"
                        defaultValue="Sign In"
                        className="mc-btn btn-style-1" >
                        {!isLoading && `Submit`}
                        {isLoading && (
                          <div className="d-flex flex-row align-center">
                            <CircularProgress
                              size={15}
                              sx={{ color: "white", marginRight: 2 }}
                            />
                            <p>Connecting</p>
                          </div>
                        )}
                      </button>
                    </div>
                    <div className="link">
                      <Link to={"/auth/register"}>
                        <i className="icon fa-solid fa-circle-arrow-right" />Don’t have account yet ? Join Us
                      </Link>
                    </div>
                  </form>
                </div>
              </div>

              <div className="image auth-image">
                <img src={process.env.REACT_APP_LOCAL_FILE_PATH + "page/large/" + page?.page_slide?.image} alt="" />
              </div>
            </div>
          </div>
        </section>
        <Footer setting={page?.setting} />
      </div>
    </div>
  );
};

export default Login;
